import { render, staticRenderFns } from "./DispatcherView.vue?vue&type=template&id=1bd2ad80&"
import script from "./DispatcherView.vue?vue&type=script&lang=js&"
export * from "./DispatcherView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports